// libs
import React, { memo, useContext } from "react";

// contexts
import { useAuthModalWrapperContext } from "shared/components/AuthModal/AuthModalWrapperContext";
import { SubNavContext } from "shared/components/SubNav";

// components
import MenuItem from "shared/components/Header/DesktopHeader/components/Auth/components/MenuItem";

// constants
import { TEXTS } from "shared/components/Header/DesktopHeader/components/Auth/constants";

function NotLoggedIn() {
    const { doHide } = useContext(SubNavContext);
    const { showAuthModal } = useAuthModalWrapperContext();

    const showModal = () => {
        showAuthModal();
        doHide();
    };

    return (
        <>
            <MenuItem onClick={showModal} iconClassName="icon-orders" title={TEXTS.MY_ORDER} />
            <MenuItem onClick={showModal} iconClassName="icon-heart" title={TEXTS.MY_WISHLIST} />
            <MenuItem onClick={showModal} iconClassName="icon-log-in" title={TEXTS.LOGIN} />
        </>
    );
}

export default memo(NotLoggedIn);
